import { useState, useEffect } from 'react'
import { useDashboardStore } from '../store/dashboardStore'
import { getStats } from '../services/api'

// Никаких демо-данных: если на бэкенде нет сделок, период вернёт пустой
// массив, а график покажет честный empty-state «Нет данных».
export function useChartData() {
  const period = useDashboardStore(s => s.period)
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    let cancelled = false

    getStats(period)
      .then(stats => {
        if (!cancelled) setChartData(stats?.chartData ?? [])
      })
      .catch(() => {
        if (!cancelled) setChartData([])
      })

    return () => { cancelled = true }
  }, [period])

  return {
    chartData,
    weeklyChartData:  chartData,
    monthlyChartData: chartData,
    dailyEquity:      chartData,
  }
}
